export default __webpack_public_path__ + "static/media/RunnerIcon.0b65cd1d.png";